module.exports = __webpack_public_path__ + "media/images/netcredit-logo-high-res-color-2c01705f.png";